export default {
      id: "edit-usage",
      viewBox: "0 0 16.89 16.5",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#edit",
      toString: function () {
        return this.url;
      }
    }